import Price from '../../../components/lakeview/Price';
import React from 'react';
import renderUtils from '../../../helpers/renderUtils';

const polishWeekdaysShort = ['nd', 'pn', 'wt', 'śr', 'cz', 'pt', 'sb'];

export function formatDateWithShortDay(dateStr) {
  const date = new Date(dateStr);
  const weekday = polishWeekdaysShort[date.getDay()];
  return `${date.toLocaleDateString('pl-PL')} (${weekday})`;
}

const columns = [
  {
    field: 'date',
    label: 'Data',
    sort: 'asc',
    width: 150,
    type: 'custom',
    custom: function (column, row) {
      return renderUtils.formatDate(row.date);
    },
  },
  {
    field: 'amount',
    label: 'Kwota',
    sort: 'asc',
    width: 150,
    type: 'custom',
    custom: function (column, row) {
      return <Price value={row.amount} />;
    },
  },
  {
    field: 'coefficient',
    label: 'Współczynnik',
    sort: 'asc',
    width: 150,
  },
];

export default columns;
